import { request } from '../utils/request'
import { stringify } from '../utils/index'
// import { baseUrl } from '../config/config_dev'
import Vue from 'vue'
const baseUrl = process.env.VUE_APP_BASE_URL
export const picUrl = baseUrl + 'v1/filestore/uploadfile' // 图片接口

const Api = {
  uploadfile: (option) => request('v1/filestore/uploadfile', option, true, true), // 用户登陆系统

  login: (option) => request('v1/sysstaff/login', option, false), // 用户登陆系统
  logout: (option) => request('v1/sysstaff/logout', option, true), // 用户退出系统
  modifypassword: option => request('v1/sysstaff/modifypassword', option), // 用户修改密码
  resetpassword: (option) => request('v1/sysstaff/resetpassword' + stringify(option), option), // 删除服务类目
  getportalmenutree: (option) => request('v1/sysstaff/getportalmenutree', option), // 查询用户的功能菜单

  getservices: (option) => request('v1/servicecata/getservices', option), // 检测机构的服务列表
  addservice: (option) => request('v1/servicecata/addservice', option), // 新增服务类目
  updateservice: (option) => request('v1/servicecata/updateservice', option), // 新增服务类目
  deleteservice: (option) => request('v1/servicecata/deleteservice' + stringify(option), option), // 删除服务类目

  getservicecategorys: (option) => request('v1/servicecata/getservicecategorys', option), // 查询服务类目列表
  addservicecategory: (option) => request('v1/servicecata/addservicecategory', option), // 新增服务类目
  updateservicecategory: (option) => request('v1/servicecata/updateservicecategory', option), // 新增服务类目
  deleteservicecategory: (option) => request('v1/servicecata/deleteservicecategory' + stringify(option), option), // 删除服务类目

  getnamecards: (option) => request('v1/namecard/getnamecards', option), // 查询电子名片列表
  addnamecard: (option) => request('v1/namecard/addnamecard', option), // 新增电子名片
  updatenamecard: (option) => request('v1/namecard/updatenamecard', option), // 新增电子名片
  deletenamecard: (option) => request('v1/namecard/deletenamecard' + stringify(option), option), // 删除电子名片
  downloadnamecardtemplate: (option) => request('v1/namecard/downloadnamecardtemplate' + stringify(option), option, true, false, true), // 下载电子名模板
  uploadnamecard: (option) => request('v1/namecard/uploadnamecard', option, true, true), // 导入电子名片

  getvendoruploadtemplate: (option) => request('v1/vendor/getvendoruploadtemplate' + stringify(option), option, true, false, true), // 下载企业模板
  uploadvendor: (option) => request('v1/vendor/uploadvendor', option, true, true), // 导入企业

  getcitytree: (option) => request('v1/area/getcitytree', option), // 省市
  getareatree: (option) => request('v1/area/getareatree', option), // 省市区

  getstaffs: option => request('v1/sysstaff/getstaffs', option), // 查询人员列表
  addstaff: option => request('v1/sysstaff/addstaff', option), // 新增人员
  updatestaff: option => request('v1/sysstaff/updatestaff', option), // 修改人员
  deletestaff: option => request('v1/sysstaff/deletestaff' + stringify(option), option), //  删除人员
  getorgportalmenutree: option => request('v1/sysstaff/getorgportalmenutree' + stringify(option), option),

  getinspectionneeds: option => request('v1/inspectionneed/getinspectionneeds', option), // 查询需求列表
  getacceptablestaffs: option => request('v1/inspectionneed/getacceptablestaffs' + stringify(option), option), // 查询分配人员列表
  acceptinspectionneed: option => request('v1/inspectionneed/acceptinspectionneed', option), // 完成需求
  notacceptinspectionneed: option => request('v1/inspectionneed/notacceptinspectionneed', option), // 完成需求
  assigninspectionneed: option => request('v1/inspectionneed/assigninspectionneed', option), // 分配需求人员列表

  confirmnamecard: option => request('v1/namecard/confirmnamecard', option), // 修改微信手机号

  getworkorders: (option) => request('v1/workorder/getworkorders', option), // 查询受理单列表
  addworkorder: (option) => request('v1/workorder/addworkorder', option), // 新增受理单
  updateworkorder: (option) => request('v1/workorder/updateworkorder', option), // 更新受理单
  deleteworkorder: (option) => request('v1/workorder/deleteworkorder' + stringify(option), option), // 删除受理单
  completionworkorder: (option) => request('v1/workorder/completionworkorder', option), // 完成受理单

  getseaports: (option) => request('v1/seaport/getseaports', option), // 查询机构列表
  getseaport: (option) => request('v1/seaport/getseaport' + stringify(option), option), // 查询机构详情
  addseaport: (option) => request('v1/seaport/addseaport', option), // 新增机构
  updateseaport: (option) => request('v1/seaport/updateseaport', option), // 更新机构
  deleteseaport: (option) => request('v1/seaport/deleteseaport' + stringify(option), option), // 删除机构
  setvendorsupervisor: (option) => request('v1/seaport/setvendorsupervisor' + stringify(option), option), // 设置监管人员

  getvendors: (option) => request('v1/vendor/getvendors', option), // 查询企业列表
  getvendornames: (option) => request('v1/vendor/getvendornames', option), // 查询企业列表
  getvendor: (option) => request('v1/vendor/getvendor' + stringify(option), option), // 查询企业详情
  addvendor: (option) => request('v1/vendor/addvendor', option), // 新增企业
  updatevendor: (option) => request('v1/vendor/updatevendor', option), // 更新企业
  deletevendor: (option) => request('v1/vendor/deletevendor' + stringify(option), option), // 删除企业

  // v1/package/getallpackages
  getallpackages: (option) => request('v1/package/getallpackages' + stringify(option), option), // 查询套餐列表
  // v1/vendor/applyvendor
  applyvendor: (option) => request('v1/vendor/applyvendor', option), // 企业申请
  getapplyvendors: (option) => request('v1/vendor/getapplyvendors', option), // 待审批企业
  auditvendor: (option) => request('v1/vendor/auditvendor', option), // 审核
  // v1/product/getproducts
  getproducts: (option) => request('v1/product/getproducts', option), // 查询商品列表
  addproduct: (option) => request('v1/product/addproduct', option), // 新增商品
  updateproduct: (option) => request('v1/product/updateproduct', option), // 更新商品
  deleteproduct: (option) => request('v1/product/deleteproduct' + stringify(option), option), // 删除商品

  captcha: (option) => request('v1/captcha/captcha', option), // 查询人员管理
  getprintusage: (option) => request('v1/logistics/getprintusage', option), // 查询人员管理

  getcertificates: option => request('v1/certificate/getcertificates', option), // 查询商品列表
  getcertificate: (option) => request('v1/certificate/getcertificate' + stringify(option), option), // 删除品牌
  addcertificate: (option) => request('v1/certificate/addcertificate', option), // 新增品牌
  updatecertificate: (option) => request('v1/certificate/updatecertificate', option), // 修改品牌
  deletecertificate: (option) => request('v1/certificate/deletecertificate' + stringify(option), option), // 删除品牌
  addcertificatefile: option => request('v1/certificate/addcertificatefile', option,), // 新增证书文件
  updatecertificatefile: option => request('v1/certificate/updatecertificatefile ', option,), // 修改证书文件
  deletecertificatefile: option => request('v1/certificate/deletecertificatefile' + stringify(option), option), // 删除证书文件

  getkeyvaluebykey: option => request('v1/keyvalue/getkeyvaluebykey' + stringify(option), option), // 查询商品列表
  setkeyvalue: option => request('v1/keyvalue/setkeyvalue', option), // 查询商品列表

  getkeyvalues: option => request('v1/keyvalue/getkeyvalues', option, true), // 通用分组列表
  getkeyvalue: option => request('v1/keyvalue/getkeyvalue' + stringify(option, true), option), // 获取通用分组
  deletekeyvalue: option => request('v1/keyvalue/deletekeyvalue' + stringify(option, true), option), // 通用分组删除
  addkeyvalue: option => request('v1/keyvalue/addkeyvalue', option), // 新增通用分组
  updatekeyvalue: option => request('v1/keyvalue/updatekeyvalue', option), // 修改通用分组

  getinfos: option => request('v1/info/getinfos', option, true), // 资讯列表
  getinfo: option => request('v1/info/getinfo' + stringify(option, true), option), // 获取资讯
  deleteinfo: option => request('v1/info/deleteinfo' + stringify(option, true), option), // 资讯删除
  addinfo: option => request('v1/info/addinfo', option), // 新增资讯
  updateinfo: option => request('v1/info/updateinfo', option), // 修改资讯

  getdisputes: option => request('v1/dispute/getdisputes', option), // 调解列表
  updatedispute: option => request('v1/dispute/updatedispute', option) // 调解列表
}
Vue.prototype.$$CommonApi = Api
export default Api
